import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React component that scrolls the window to the top whenever the route changes.
 * Utilizes the `useLocation` hook from `react-router-dom` to detect path changes.
 * Does not render any UI.
 *
 * @function
 * @returns {null} This component does not render anything.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // No rendering
};

export default ScrollToTop;
